import React from "react";
import { TextInput } from "react-native";
import { Text, View } from "native-base";
import { Search } from "lucide-react-native";
import { webFont } from "../../../Universal/API/API";
import PressableWrapp from "../../../Universal/Buttons/PressableReact/PressableWrapp";
import { webCursorPointer } from "./helpers";
import type { HistoryStatusFilter } from "./types";

type ControlsProps = {
  scaleAll: number;
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  statusFilter: HistoryStatusFilter;
  onStatusFilterChange: (value: HistoryStatusFilter) => void;
};

const OPTIONS: Array<{ key: HistoryStatusFilter; label: string }> = [
  { key: "all", label: "Все" },
  { key: "draft", label: "Сохранён" },
  { key: "submitted", label: "Оформлен" },
];

const Controls: React.FC<ControlsProps> = ({
  scaleAll,
  searchQuery,
  onSearchQueryChange,
  statusFilter,
  onStatusFilterChange,
}) => {
  return (
    <>
      <View
        style={{
          flexDirection: "row",
          gap: 8 * scaleAll,
          marginBottom: 12 * scaleAll,
        }}
      >
        {OPTIONS.map((option) => {
          const selected = statusFilter === option.key;

          return (
            <PressableWrapp
              key={option.key}
              onPress={() => onStatusFilterChange(option.key)}
              style={[
                {
                  minHeight: 34 * scaleAll,
                  borderRadius: 12 * scaleAll,
                  backgroundColor: selected ? "#111111" : "#F7F5F0",
                  borderWidth: 1,
                  borderColor: selected ? "#111111" : "#ECE8E1",
                  paddingHorizontal: 12 * scaleAll,
                  alignItems: "center",
                  justifyContent: "center",
                },
                webCursorPointer,
              ]}
            >
              <Text
                selectable={false}
                style={{
                  fontFamily: webFont("Inter"),
                  fontSize: 12 * scaleAll,
                  color: selected ? "#FFFFFF" : "#111111",
                  fontWeight: "700",
                }}
              >
                {option.label}
              </Text>
            </PressableWrapp>
          );
        })}
      </View>

      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          minHeight: 42 * scaleAll,
          borderRadius: 14 * scaleAll,
          borderWidth: 1,
          borderColor: "#ECE8E1",
          backgroundColor: "#FBFAF8",
          paddingHorizontal: 12 * scaleAll,
          marginBottom: 14 * scaleAll,
        }}
      >
        <Search size={16 * scaleAll} color="#7A746C" />
        <TextInput
          value={searchQuery}
          onChangeText={onSearchQueryChange}
          placeholder="Поиск по номеру, имени или дате"
          placeholderTextColor="#9A948B"
          style={{
            flex: 1,
            marginLeft: 8 * scaleAll,
            color: "#111111",
            fontFamily: webFont("Inter"),
            fontSize: 13 * scaleAll,
          } as any}
        />
      </View>
    </>
  );
};

export default React.memo(Controls);
